/* ---------- carrito lateral ----------
   Todo lo que agrega al carrito pasa por acá: nunca se navega a /cart.
   Pedimos la sección del drawer de nuevo, reemplazamos SOLO el interior
   (reemplazar el <dialog> lo cerraría) y abrimos el cajón de Horizon. */
window.RD_CARRITO = (function () {
  var EVENTOS_URL = 'https://cdn.shopify.com/storefront/standard-events.js';
  var modulo = null;

  function eventos() {
    if (!modulo) modulo = import(EVENTOS_URL).catch(function () { return null; });
    return modulo;
  }
  function burbuja(cantidad) {
    var sel = '.theme-drawer__badge, .cart-bubble__text, [data-cart-count]';
    Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) {
      if (/^\s*\d+\s*$/.test(el.textContent)) el.textContent = cantidad;
    });
  }
  function abrir() {
    var d = document.getElementById('cart-drawer');
    if (d && typeof d.open === 'function') { d.open(); return true; }
    var icono = document.querySelector('[href$="/cart"]');
    if (icono) { icono.click(); return true; }
    return false;
  }

  /* Plan B, por si el módulo de eventos no carga: pedimos la sección del drawer
     y reemplazamos solo el interior. Reemplazar el <dialog> lo cerraría. */
  function manual(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return fetch('/?sections=cart-drawer-section').then(function (x) { return x.json(); });
    }).then(function (secciones) {
      var html = secciones['cart-drawer-section'];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevo = doc.querySelector('.cart-drawer__inner');
        var actual = document.querySelector('#cart-drawer .cart-drawer__inner');
        if (nuevo && actual) actual.replaceWith(nuevo);
      }
      return fetch('/cart.js').then(function (x) { return x.json(); });
    }).then(function (carrito) { burbuja(carrito.item_count); abrir(); return carrito; });
  }

  /* Camino bueno: le avisamos a Horizon con el evento estándar de Shopify.
     El tema se encarga del estado de carga, de redibujar el carrito y de abrir
     el cajón solo. Por eso acá NO tocamos el HTML del drawer a mano. */
  function agregar(items) {
    return eventos().then(function (m) {
      var E = m && m.CartLinesUpdateEvent;
      if (!E) return manual(items);
      var p = E.createPromise();
      document.dispatchEvent(new E({
        action: 'add',
        source: 'rancho-doble',
        lines: items.map(function (i) { return { merchandiseId: i.id, quantity: i.quantity }; }),
        promise: p.promise
      }));
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        return fetch('/cart.js').then(function (x) { return x.json(); });
      }).then(function (carrito) {
        p.resolve(E.createCartFromAjaxResponse(carrito));
        abrir();
        return carrito;
      }).catch(function (e) {
        if (p.reject) p.reject(e);
        throw e;
      });
    });
  }

  return { agregar: agregar, abrir: abrir, burbuja: burbuja };
})();

/* Ningún link del sitio manda a la página del carrito: abren el cajón. */
document.addEventListener('click', function (e) {
  var a = e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
  if (!a) return;
  var d = document.getElementById('cart-drawer');
  if (!d || typeof d.open !== 'function') return;
  e.preventDefault();
  d.open();
});

/* RANCHO DOBLE — comportamiento de las secciones rd-* (tema Horizon).
   Los datos del producto llegan en window.RD_DATA, que arma sections/rd-pdp.liquid. */
(function () {
  'use strict';
  if (window.__RD_INIT) return; window.__RD_INIT = true;
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ============ aparición al hacer scroll ============ */
  var reveals = $$('.rd-reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('rd-is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    reveals.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 1.2) el.classList.add('rd-is-in');
      else io.observe(el);
    });
  } else {
    reveals.forEach(function (el) { el.classList.add('rd-is-in'); });
  }

  /* ============ cinta: duplicar el contenido para que el loop no corte ============ */
  $$('.rd-mrq__track').forEach(function (t) {
    if (t.dataset.doubled) return;
    var clon = t.cloneNode(true);
    $$('*', clon).forEach(function (n) { n.setAttribute('aria-hidden', 'true'); });
    while (clon.firstChild) t.appendChild(clon.firstChild);
    t.dataset.doubled = '1';
  });

  /* ============ zoom del bloque editorial ============ */
  $$('.rd-tela__media').forEach(function (m) {
    var fijado = false;
    m.addEventListener('click', function () { fijado = !fijado; m.classList.toggle('rd-is-zoom', fijado); });
    m.addEventListener('mouseenter', function () { m.classList.add('rd-is-zoom'); });
    m.addEventListener('mouseleave', function () { if (!fijado) m.classList.remove('rd-is-zoom'); });
  });

  /* ============ coverflow ============ */
  $$('.rd-mov__row').forEach(function (row) {
    function marcar() {
      if (window.innerWidth >= 990) { $$('.rd-mov__slide', row).forEach(function (s) { s.classList.remove('rd-is-mid'); }); return; }
      var c = row.getBoundingClientRect().left + row.clientWidth / 2, mejor = null, dmin = Infinity;
      $$('.rd-mov__slide', row).forEach(function (s) {
        var r = s.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - c);
        if (d < dmin) { dmin = d; mejor = s; }
      });
      $$('.rd-mov__slide', row).forEach(function (s) { s.classList.toggle('rd-is-mid', s === mejor); });
    }
    row.addEventListener('scroll', marcar, { passive: true });
    window.addEventListener('resize', marcar);
    marcar();
  });

  /* ============ flechas de los estantes horizontales ============ */
  $$('.rd-shelf__wrap').forEach(function (wrap) {
    var row = $('.rd-shelf__row', wrap);
    var prev = $('.rd-shelf__nav.rd-prev', wrap), next = $('.rd-shelf__nav.rd-next', wrap);
    if (!row || !prev || !next) return;
    function paso() { var c = $('.rd-card', row); return c ? c.offsetWidth + 28 : row.clientWidth * 0.8; }
    function estado() {
      var hay = row.scrollWidth - row.clientWidth > 4;
      prev.disabled = !hay || row.scrollLeft < 8;
      next.disabled = !hay || row.scrollLeft > row.scrollWidth - row.clientWidth - 8;
    }
    prev.addEventListener('click', function () { row.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { row.scrollBy({ left: paso(), behavior: 'smooth' }); });
    row.addEventListener('scroll', estado, { passive: true });
    window.addEventListener('resize', estado);
    estado();
  });


  /* ====================================================================
     FICHA SIMPLE (cualquier producto que no sea la bombacha)
     ==================================================================== */
  (function () {
    var raiz = $('[data-rd-basico]');
    var B = window.RD_BASICO;
    if (!raiz || !B) return;

    var track = $('[data-rd-b-track]', raiz), thumbs = $('[data-rd-b-thumbs]', raiz);

    /* miniaturas */
    if (track && thumbs) {
      var botones = $$('button', thumbs);
      botones.forEach(function (b, i) {
        b.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); });
      });
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        botones.forEach(function (b, k) { b.setAttribute('aria-current', String(k === i)); });
      }, { passive: true });
    }

    if (!B.variantes.length) return;

    /* Un solo producto sin variantes reales: el selector "Title / Talle único" sobra.
       Ojo: esconder TODOS los .rd-field también escondía el bloque de packs, que es
       un .rd-field más. Solo se ocultan los que tienen un selector de opción adentro. */
    if (B.variantes.length === 1) {
      $$('#rd-buy .rd-field', raiz).forEach(function (f) {
        if (f.querySelector('[data-rd-b-opt]')) f.hidden = true;
      });
    }

    var inicial = B.variantes.filter(function (v) { return v.disp; })[0] || B.variantes[0];
    var elegido = inicial.o.slice();

    function fmt(c) {
      var n = c / 100;
      return '$' + n.toLocaleString('es-UY', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
    }
    function buscar(vals) {
      for (var i = 0; i < B.variantes.length; i++) {
        var v = B.variantes[i], igual = true;
        for (var k = 0; k < vals.length; k++) { if (v.o[k] !== vals[k]) { igual = false; break; } }
        if (igual) return v;
      }
      return null;
    }
    /* ¿existe alguna variante disponible con este valor en esta posición,
       respetando lo que ya eligió el usuario en las otras? */
    function hayCon(pos, val) {
      return B.variantes.some(function (v) {
        if (!v.disp || v.o[pos] !== val) return false;
        for (var k = 0; k < elegido.length; k++) { if (k !== pos && v.o[k] !== elegido[k]) return false; }
        return true;
      });
    }

    /* si la opción es un color y hay una foto cuyo alt lo menciona, la galería salta ahí */
    function fotoDeColor(val) {
      if (!track || !val) return;
      var imgs = $$('img', track), v = val.toLowerCase();
      for (var i = 0; i < imgs.length; i++) {
        if ((imgs[i].alt || '').toLowerCase().indexOf(v) !== -1) {
          // 'smooth' pelea con scroll-snap mandatory y el navegador vuelve al inicio
          track.scrollTo({ left: track.clientWidth * i, behavior: 'auto' });
          return;
        }
      }
    }

    function pintar() {
      $$('[data-rd-b-opt]', raiz).forEach(function (b) {
        var pos = parseInt(b.dataset.rdBOpt, 10), val = b.dataset.rdBVal;
        b.setAttribute('aria-pressed', String(elegido[pos] === val));
        var posible = hayCon(pos, val);
        b.disabled = !posible && elegido[pos] !== val;
      });
      $$('[data-rd-b-nombre]', raiz).forEach(function (e) {
        e.textContent = elegido[parseInt(e.dataset.rdBNombre, 10)] || '';
      });
      var v = buscar(elegido);
      var atc = $('[data-rd-b-atc]', raiz), lista = $('[data-rd-b-lista]', raiz);
      $('[data-rd-b-precio]', raiz).textContent = v ? fmt(v.precio) : '';
      if (lista) {
        if (v && v.lista > v.precio) { lista.hidden = false; lista.textContent = fmt(v.lista); }
        else lista.hidden = true;
      }
      if (v) $('[data-rd-b-id]', raiz).value = v.id;
      if (atc) {
        var ok = v && v.disp;
        atc.disabled = !ok;
        atc.textContent = ok ? 'Agregar al carrito' : (v ? 'Sin stock en esa combinación' : 'Elegí una combinación disponible');
      }
    }

    $$('[data-rd-b-opt]', raiz).forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        var pos0 = parseInt(b.dataset.rdBOpt, 10);
        elegido[pos0] = b.dataset.rdBVal;
        if (/color/i.test(B.opciones[pos0] || '')) fotoDeColor(b.dataset.rdBVal);
        // si la combinación quedó sin stock, corrijo la última opción a una que sí exista
        if (!(buscar(elegido) || {}).disp) {
          var pos = elegido.length - 1;
          var alt = B.variantes.filter(function (v) {
            if (!v.disp) return false;
            for (var k = 0; k < pos; k++) { if (v.o[k] !== elegido[k]) return false; }
            return true;
          })[0];
          if (alt) elegido[pos] = alt.o[pos];
        }
        pintar();
      });
    });

    /* ---------- packs (solo productos de una sola variante) ---------- */
    var cantInput = $('[data-rd-b-cant]', raiz);
    var packs = B.packs || {}, pack = 1;

    function pintarPack() {
      var total = packs[pack], lista = packs[1] * pack;
      $('[data-rd-b-precio]', raiz).textContent = fmt(total);
      var was = $('[data-rd-b-lista]', raiz), off = $('[data-rd-b-off]', raiz),
          call = $('[data-rd-b-callout]', raiz), badge = $('[data-rd-b-badge]', raiz),
          atc = $('[data-rd-b-atc]', raiz);
      if (cantInput) cantInput.value = pack;
      if (pack === 1) {
        if (was) was.hidden = true;
        if (off) off.hidden = true;
        if (badge) badge.hidden = true;
        if (call) {
          call.innerHTML = packs[3] > 0
            ? 'Llevando 2 pagás <b>' + fmt(packs[2]) + '</b> y llevando 3, <b>' + fmt(packs[3]) + '</b>'
            : 'Llevando 2 pagás <b>' + fmt(packs[2]) + '</b>';
        }
        if (atc) atc.textContent = 'Agregar al carrito · ' + fmt(total);
      } else {
        var pct = Math.round((1 - total / lista) * 100);
        if (was) { was.hidden = false; was.textContent = fmt(lista); }
        if (off) { off.hidden = false; off.textContent = '−' + pct + '%'; }
        if (badge) {
          badge.hidden = false;
          badge.querySelector('b').textContent = '−' + pct + '%';
          badge.querySelector('span').textContent = 'pack de ' + pack;
        }
        if (call) call.innerHTML = 'Llevás ' + pack + ' y ahorrás <b>' + fmt(lista - total) +
          '</b> · ' + fmt(Math.round(total / pack)) + ' cada uno';
        if (atc) atc.textContent = 'Agregar los ' + pack + ' · ' + fmt(total);
      }
      var sbP = $('[data-rd-b-sb-precio]', raiz), sbM = $('[data-rd-b-sb-meta]', raiz);
      if (sbP) sbP.textContent = fmt(total);
      if (sbM) sbM.textContent = pack === 1 ? '1 unidad' : pack + ' unidades';
    }

    $$('[data-rd-b-pack]', raiz).forEach(function (b) {
      b.addEventListener('click', function () {
        pack = parseInt(b.dataset.rdBPack, 10);
        $$('[data-rd-b-pack]', raiz).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        pintarPack();
      });
    });

    /* ---------- barra fija ---------- */
    var sticky = $('[data-rd-b-sticky]', raiz), atcPrincipal = $('[data-rd-b-atc]', raiz);
    if (sticky && atcPrincipal) {
      var sbAdd = $('[data-rd-b-sb-add]', raiz);
      if (sbAdd) sbAdd.addEventListener('click', function () { atcPrincipal.click(); });
      var evaluar = function () {
        var on = atcPrincipal.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('rd-is-on', on);
        document.documentElement.classList.toggle('rd-sticky-on', on);
      };
      ['scroll', 'resize'].forEach(function (e) { window.addEventListener(e, evaluar, { passive: true }); });
      evaluar();
    }

    pintar();
    if ($('[data-rd-b-packs]') || raiz.hasAttribute('data-rd-b-packs')) pintarPack();
  })();

  /* ====================================================================
     FICHA DE PRODUCTO
     ==================================================================== */
  var D = window.RD_DATA;
  var pdp = $('[data-rd-pdp]');
  if (!pdp || !D) return;

  /* El color de arranque lo elige la ficha (D.color_inicial). Si no está o no
     existe entre las opciones, cae al primero, como antes. */
  var colorInicial = D.colores.indexOf(D.color_inicial) >= 0 ? D.color_inicial : D.colores[0];
  var st = { color: colorInicial, talle: null, pack: 1 };
  /* Cuántas fotos entran en la galería por color. Con 5 colores y ocho tomas
     cada uno la tira de miniaturas se vuelve ilegible. */
  var TOPE_FOTOS = D.tope_fotos || 5;

  function fmt(centavos) {
    var n = centavos / 100;
    return '$' + n.toLocaleString('es-UY', {
      minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2
    });
  }
  function fotos(color) {
    var f = (D.fotos[color] || []).slice();
    f.sort(function (a, b) { return a.n - b.n; });
    if (!f.length) f = (D.fotos[colorInicial] || D.fotos[D.colores[0]] || []).slice();
    return f.slice(0, TOPE_FOTOS);
  }
  function variante(color, talle) { return D.variantes[color + '|' + talle] || null; }

  /* ---------- galería ---------- */
  var track = $('[data-rd-track]'), thumbs = $('[data-rd-thumbs]'), lb = $('[data-rd-lb]'),
      lbTrack = $('[data-rd-lb-track]'), lbVolver = null;

  function cerrarLb() {
    if (!lb || !lb.classList.contains('rd-is-on')) return;
    lb.classList.remove('rd-is-on'); document.body.classList.remove('rd-no-scroll');
    if (lbVolver) { lbVolver.focus(); lbVolver = null; }
  }
  function abrirLb(i, origen) {
    if (!lb) return;
    lbVolver = origen || document.activeElement;
    lb.classList.add('rd-is-on'); document.body.classList.add('rd-no-scroll');
    var imgs = $$('img', lbTrack);
    if (imgs[i]) lbTrack.scrollTo({ left: imgs[i].offsetLeft, behavior: 'auto' });
    $('[data-rd-lb-x]').focus();
  }
  if (lb) {
    $('[data-rd-lb-x]').addEventListener('click', cerrarLb);
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target === lbTrack) cerrarLb(); });
    $$('[data-rd-lb-nav]', lb).forEach(function (b) {
      b.addEventListener('click', function () {
        lbTrack.scrollBy({ left: (b.dataset.rdLbNav === 'next' ? 1 : -1) * lbTrack.clientWidth, behavior: 'smooth' });
      });
    });
    lb.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var foco = $$('button', lb).filter(function (b) { return b.offsetParent !== null; });
      if (!foco.length) return;
      var pri = foco[0], ult = foco[foco.length - 1];
      if (e.shiftKey && document.activeElement === pri) { e.preventDefault(); ult.focus(); }
      else if (!e.shiftKey && document.activeElement === ult) { e.preventDefault(); pri.focus(); }
    });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrarLb(); });

  function pintarGaleria() {
    var f = fotos(st.color);
    track.innerHTML = ''; thumbs.innerHTML = ''; lbTrack.innerHTML = '';
    f.forEach(function (foto, i) {
      var img = new Image();
      img.width = 1120; img.height = 1400;
      if (i > 0) img.loading = 'lazy';
      img.alt = foto.a || '';
      img.srcset = foto.u2 + ' 560w, ' + foto.u + ' 1120w';
      img.sizes = '(min-width:990px) 520px, 100vw';
      img.src = foto.u;
      img.tabIndex = 0; img.setAttribute('role', 'button');
      img.addEventListener('click', function () { abrirLb(i, img); });
      img.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); abrirLb(i, img); }
      });
      track.appendChild(img);

      var big = new Image(); big.loading = 'lazy'; big.alt = foto.a || ''; big.src = foto.u;
      lbTrack.appendChild(big);

      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('aria-current', String(i === 0)); b.setAttribute('aria-label', foto.a || '');
      b.innerHTML = '<img src="' + foto.u2 + '" alt="" loading="lazy" width="112" height="140">';
      b.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); });
      thumbs.appendChild(b);
    });
    track.scrollLeft = 0;
    marcarFoto(0);
  }
  function marcarFoto(i) {
    $$('button', thumbs).forEach(function (b, k) { b.setAttribute('aria-current', String(k === i)); });
  }
  track.addEventListener('scroll', function () {
    marcarFoto(Math.round(track.scrollLeft / track.clientWidth));
  }, { passive: true });

  /* ---------- color ---------- */
  function aplicarColor(nombre, desdeGrilla) {
    st.color = nombre;
    $$('[data-rd-color]').forEach(function (x) {
      x.setAttribute('aria-pressed', String(x.dataset.rdColor === nombre));
    });
    $('[data-rd-color-nombre]').textContent = nombre;
    pintarGaleria(); pintarTalles(); sincronizarUnidades(); pintarSticky(); evaluarSticky();
    if (desdeGrilla) { var g = $('.rd-pdp'); if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }
  $$('[data-rd-color]').forEach(function (b) {
    b.addEventListener('click', function () { aplicarColor(b.dataset.rdColor, !!b.closest('[data-rd-grilla]')); });
  });

  /* ---------- talle ---------- */
  function pintarTalles() {
    $$('[data-rd-talle]').forEach(function (b) {
      var v = variante(st.color, b.dataset.rdTalle);
      var hay = !!(v && v.disp);
      b.disabled = !hay;
      b.classList.toggle('rd-agotado', !hay);
      b.setAttribute('aria-pressed', String(b.dataset.rdTalle === st.talle));
    });
    if (st.talle && !(variante(st.color, st.talle) || {}).disp) {
      st.talle = null;
      $('[data-rd-talle-nombre]').textContent = '';
      $$('[data-rd-talle]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    }
  }
  $$('[data-rd-talle]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.disabled) return;
      st.talle = b.dataset.rdTalle;
      $$('[data-rd-talle]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      $('[data-rd-talle-nombre]').textContent = '· ' + st.talle;
      sincronizarUnidades(); pintarSticky(); evaluarSticky();
    });
  });

  /* ---------- packs ---------- */
  $$('[data-rd-pack]').forEach(function (b) {
    b.addEventListener('click', function () {
      st.pack = parseInt(b.dataset.rdPack, 10);
      $$('[data-rd-pack]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      pintarPrecio(); sincronizarUnidades(); pintarSticky(); evaluarSticky();
    });
  });

  function pintarPrecio() {
    var total = D.packs[st.pack], lista = D.packs[1] * st.pack;
    $('[data-rd-precio]').textContent = fmt(total);
    var was = $('[data-rd-lista]'), off = $('[data-rd-off]'), call = $('[data-rd-callout]'),
        badge = $('[data-rd-badge]'), atc = $('[data-rd-atc]');
    if (st.pack === 1) {
      /* Con una sola unidad el tachado sale del precio de lista de Shopify.
         Sin precio de lista cargado no se muestra nada: no se inventa un antes. */
      badge.hidden = true;
      if (D.lista1 && D.lista1 > total) {
        var pct1 = Math.round((1 - total / D.lista1) * 100);
        was.hidden = false; was.textContent = fmt(D.lista1);
        off.hidden = false; off.textContent = '−' + pct1 + '%';
      } else {
        was.hidden = true; off.hidden = true;
      }
      call.innerHTML = 'Llevando 2 pagás <b>' + fmt(D.packs[2]) + '</b> y llevando 3, <b>' + fmt(D.packs[3]) + '</b>';
      atc.textContent = 'Agregar al carrito · ' + fmt(total);
    } else {
      var pct = Math.round((1 - total / lista) * 100);
      was.hidden = false; was.textContent = fmt(lista);
      off.hidden = false; off.textContent = '−' + pct + '%';
      badge.hidden = false;
      $('[data-rd-badge] b').textContent = '−' + pct + '%';
      $('[data-rd-badge] span').textContent = 'pack de ' + st.pack;
      call.innerHTML = 'Llevás ' + st.pack + ' bombachas y ahorrás <b>' + fmt(lista - total) + '</b> · ' +
                       fmt(Math.round(total / st.pack)) + ' cada una';
      atc.textContent = 'Agregar las ' + st.pack + ' · ' + fmt(total);
    }
    $('[data-rd-packbox]').hidden = st.pack === 1;
  }

  /* ---------- unidades del pack ---------- */
  var unitsBox = $('[data-rd-units]'), unitsList = $('[data-rd-units-list]'), unidades = [];

  function opcionesColor(sel) {
    return D.colores.map(function (c) {
      return '<option value="' + c + '"' + (c === sel ? ' selected' : '') + '>' + c + '</option>';
    }).join('');
  }
  function opcionesTalle(color, sel) {
    var o = '<option value="">Talle</option>';
    D.talles.forEach(function (t) {
      var v = variante(color, t);
      if (!v || !v.disp) return;
      o += '<option value="' + t + '"' + (t === sel ? ' selected' : '') + '>' + t + '</option>';
    });
    return o;
  }
  function filaUnidad(i, color, talle) {
    var row = document.createElement('div');
    row.className = 'rd-unit' + (i === 0 ? ' rd-unit--primera' : '');
    row.innerHTML =
      '<span class="rd-u-n">Unidad ' + (i + 1) + '</span>' +
      '<select data-rd-u-color aria-label="Color de la unidad ' + (i + 1) + '">' + opcionesColor(color) + '</select>' +
      '<select data-rd-u-talle aria-label="Talle de la unidad ' + (i + 1) + '">' + opcionesTalle(color, talle) + '</select>';
    var selColor = row.querySelector('[data-rd-u-color]');
    var selTalle = row.querySelector('[data-rd-u-talle]');
    selColor.addEventListener('change', function (e) {
      var actual = selTalle.value;
      selTalle.innerHTML = opcionesTalle(e.target.value, actual);
      guardarUnidades();
      // la unidad 1 es la que manda la galería y los selectores de arriba
      if (i === 0) espejarArriba(e.target.value, selTalle.value);
    });
    selTalle.addEventListener('change', function () {
      guardarUnidades();
      if (i === 0) espejarArriba(selColor.value, selTalle.value);
    });
    return row;
  }

  /* La unidad 1 y los selectores de arriba son lo mismo: se copian en los dos sentidos. */
  function espejarArriba(color, talle) {
    if (color && color !== st.color) {
      st.color = color;
      unidades[0] = unidades[0] || {}; unidades[0].color = color;
      $$('[data-rd-color]').forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.rdColor === color)); });
      $('[data-rd-color-nombre]').textContent = color;
      pintarGaleria(); pintarTalles();
    }
    st.talle = talle || null;
    unidades[0] = unidades[0] || {}; unidades[0].talle = st.talle || '';
    $$('[data-rd-talle]').forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.rdTalle === st.talle)); });
    $('[data-rd-talle-nombre]').textContent = st.talle ? '\u00b7 ' + st.talle : '';
    pintarSticky(); evaluarSticky();
  }
  function guardarUnidades() {
    $$('[data-rd-u-color]', unitsList).forEach(function (s, k) { unidades[k] = unidades[k] || {}; unidades[k].color = s.value; });
    $$('[data-rd-u-talle]', unitsList).forEach(function (s, k) { unidades[k] = unidades[k] || {}; unidades[k].talle = s.value; });
  }
  function sincronizarUnidades() {
    guardarUnidades();
    if (st.pack === 1) { unitsBox.hidden = true; return; }
    unitsBox.hidden = false;
    unidades[0] = { color: st.color, talle: st.talle || '' };
    unitsList.innerHTML = '';
    for (var i = 0; i < st.pack; i++) {
      var u = unidades[i] || {};
      unitsList.appendChild(filaUnidad(i, u.color || st.color, u.talle || ''));
    }
  }

  /* ---------- barra fija ---------- */
  var sticky = $('[data-rd-sticky]');
  function pintarSticky() {
    var f = fotos(st.color)[0];
    if (f) $('[data-rd-sb-img]').src = f.u2;
    $('[data-rd-sb-meta]').textContent =
      st.color + (st.talle ? ' · Talle ' + st.talle : ' · Elegí el talle') +
      ' · ' + st.pack + (st.pack === 1 ? ' unidad' : ' unidades');
    $('[data-rd-sb-precio]').textContent = fmt(D.packs[st.pack]);
  }
  function evaluarSticky() {
    var atc = $('[data-rd-atc]');
    var on = atc.getBoundingClientRect().bottom < 0;
    sticky.classList.toggle('rd-is-on', on);
    document.documentElement.classList.toggle('rd-sticky-on', on);
  }
  ['scroll', 'resize'].forEach(function (e) { window.addEventListener(e, evaluarSticky, { passive: true }); });

  /* ---------- agregar al carrito de verdad ---------- */
  function lineas() {
    var items = [], falta = [];
    if (st.pack === 1) {
      if (!st.talle) { falta.push('el talle'); return { falta: falta }; }
      var v = variante(st.color, st.talle);
      if (!v) { falta.push('una combinación disponible'); return { falta: falta }; }
      items.push({ id: v.id, quantity: 1 });
    } else {
      $$('.rd-unit', unitsList).forEach(function (row, i) {
        var c = row.querySelector('[data-rd-u-color]').value;
        var t = row.querySelector('[data-rd-u-talle]').value;
        if (!t) { falta.push('el talle de la unidad ' + (i + 1)); return; }
        var v = variante(c, t);
        if (v) items.push({ id: v.id, quantity: 1 });
      });
    }
    return { items: items, falta: falta };
  }

  $$('[data-rd-add]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var av = $('[data-rd-aviso]');
      var r = lineas();
      if (r.falta.length) {
        av.textContent = 'Falta elegir ' + r.falta.join(', ') + '.';
        av.hidden = false;
        clearTimeout(av._t); av._t = setTimeout(function () { av.hidden = true; }, 4000);
        return;
      }
      var textoPrevio = b.textContent;
      b.disabled = true; b.textContent = 'Agregando…';
      window.RD_CARRITO.agregar(r.items).then(function () {
        b.disabled = false; b.textContent = textoPrevio;
      }).catch(function () {
        b.disabled = false; b.textContent = textoPrevio;
        av.textContent = 'No pudimos agregarlo. Probá de nuevo o escribinos por WhatsApp.';
        av.hidden = false;
      });
    });
  });

  pintarGaleria(); pintarTalles(); pintarPrecio(); sincronizarUnidades(); pintarSticky(); evaluarSticky();
})();

/* ---------- Sumá a tu pedido · botón del cart drawer ----------
   El drawer lo vuelve a dibujar Shopify entero, así que el listener va en
   document una sola vez. Después de agregar, pedimos la sección de nuevo y
   reemplazamos solo el interior: si reemplazáramos el <dialog> se cerraría. */
(function () {
  var trabajando = false;

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rd-up-add]');
    if (!b || trabajando) return;
    e.preventDefault();
    trabajando = true;
    var texto = b.textContent;
    b.disabled = true;
    b.textContent = 'Agregando…';

    window.RD_CARRITO.agregar([{ id: Number(b.getAttribute('data-rd-up-add')), quantity: 1 }])
      .catch(function () {
        b.disabled = false;
        b.textContent = 'Probá de nuevo';
        setTimeout(function () { b.textContent = texto; }, 2500);
      })
      .then(function () { trabajando = false; });
  });
})();


/* ---------- ficha genérica: el form nativo iría a /cart ----------
   Lo interceptamos para que agregue por fetch y abra el cajón. */
(function () {
  var form = document.getElementById('rd-buy');
  if (!form) return;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var b = form.querySelector('[data-rd-b-atc]');
    var datos = new FormData(form);
    var id = datos.get('id');
    var cantidad = Number(datos.get('quantity') || 1);
    if (!id) return;
    var texto = b ? b.textContent : '';
    if (b) { b.disabled = true; b.textContent = 'Agregando…'; }
    window.RD_CARRITO.agregar([{ id: Number(id), quantity: cantidad }])
      .catch(function () {
        if (b) b.textContent = 'Probá de nuevo';
      })
      .then(function () {
        if (b) { b.disabled = false; setTimeout(function () { b.textContent = texto; }, 400); }
      });
  });
})();
